import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'

import { bytesToSize } from '../../../helpers/general'
import { newFetch, GET, PUT } from '../../../helpers/fetch'

import jpgIcon from '../../../assets/icons/jpg.png'
import pdfIcon from '../../../assets/icons/pdf.png'
import pngIcon from '../../../assets/icons/png.png'

import { config } from '../../../config'

const { SERVER_URL } = config

const InstructionDetail = ({
  history,
  match: {
    params: { instruction_id },
  },
}) => {
  const [instruction, setInstruction] = useState(null)

  const fetchInstruction = async () => {
    let api_path = `/communication/${instruction_id}`
    let response = await newFetch(GET, api_path)

    if (response.success) {
      setInstruction(response.data)
    }
  }

  const handleMarkAsRead = async () => {
    let api_path = `/communication/${instruction_id}/read`
    await newFetch(PUT, api_path)
  }

  useEffect(() => {
    fetchInstruction()
  }, [])

  useEffect(() => {
    if (instruction && !instruction.is_read) {
      handleMarkAsRead()
    }
  }, [instruction])

  return (
    <div className="container pt-4">
      <h4 style={{ wordBreak: 'break-all' }}>
        {instruction && instruction.title}
      </h4>
      <p style={{ whiteSpace:"pre-line"}}>
        {instruction && instruction.description}
      </p>


          
      
      
      
      <div className="mt-2">
        {instruction ? null : <strong className="mt-3">Attached File(s)</strong>}
        {instruction &&
          instruction.uploads.map((file, index) => (
            <div
              key={index}
              className="d-flex justify-content-between align-items-center border rounded px-3 py-2 mb-2"
              style={{ backgroundColor: '#efefef' }}
              onClick={() => window.open(`${SERVER_URL}/${file.url}`, '_blank')}
            >
              <div className="d-flex w-100 flex-row justify-content-between align-items-center py-2">
                {file.url.split('/')[2].split('.')[1] === 'jpeg' ||
                file.url.split('/')[2].split('.')[1] === 'jpg' ? (
                  <img src={jpgIcon} style={{ width: '30px' }} alt="" />
                ) : file.url.split('/')[2].split('.')[1] === 'png' ? (
                  <img src={pngIcon} style={{ width: '30px' }} alt="" />
                ) : file.url.split('/')[2].split('.')[1] === 'pdf' ? (
                  <img src={pdfIcon} style={{ width: '30px' }} alt="" />
                ) : (
                  ''
                )}
                <div className="d-flex flex-column flex-grow-1 ml-4">
                  <div>{file.url.split('/')[2]}</div>
                  {/* <small className="text-muted">{bytesToSize(file.size)}</small> */}
                </div>
              </div>
            </div>
          ))}
      </div>
    </div>
  )
}

export default withRouter(InstructionDetail)
